import { render, staticRenderFns } from "./BannerComp.vue?vue&type=template&id=66ab82f8&scoped=true"
import script from "./BannerComp.vue?vue&type=script&lang=js"
export * from "./BannerComp.vue?vue&type=script&lang=js"
import style0 from "./BannerComp.vue?vue&type=style&index=0&id=66ab82f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab82f8",
  null
  
)

export default component.exports